/** Память «константных» фильтров страницы (период, вкладка, дата) между
 *  переходами по сайдбару (владелец, 17.09 п. 73/74: «навигационная кнопка
 *  сбрасывает константные дропдауны/фильтры»).
 *
 *  Состояние фильтров живёт в URL — это правильно (ссылка делится), но ссылки
 *  сайдбара вели на голый путь, и период с вкладкой сбрасывались. Теперь
 *  страница запоминает СВОИ ключи по своему пути (useRememberFilters), а
 *  сайдбар подставляет их в момент клика (Sidebar.searchFor). sessionStorage:
 *  живёт в одной вкладке браузера и умирает с ней — как и должен «текущий»
 *  фильтр; ключи разных страниц не смешиваются. */
const KEY = (pathname: string) => `filters:${pathname}`;

export function rememberFilters(pathname: string, params: URLSearchParams, keys: readonly string[]): void {
  try {
    // Слияние, а не замена: одну страницу могут помнить два компонента
    // (Статистика и её вкладка «Тепловая карта» — разные ключи, один путь).
    const out = recallFilters(pathname);
    for (const k of keys) {
      const v = params.get(k);
      if (v != null) out.set(k, v); else out.delete(k);
    }
    const s = out.toString();
    if (s) sessionStorage.setItem(KEY(pathname), s); else sessionStorage.removeItem(KEY(pathname));
  } catch {
    // Приватное окно / storage запрещён — фильтр просто не запомнится.
  }
}

export function recallFilters(pathname: string): URLSearchParams {
  try {
    return new URLSearchParams(sessionStorage.getItem(KEY(pathname)) ?? '');
  } catch {
    return new URLSearchParams();
  }
}
